import autoComplete from '@tarekraafat/autocomplete.js'

const AutocompleteField = (function () {
  const selector = '.js-autocomplete'
  const elements = document.querySelectorAll(selector)
  const silverstripeData = window?.TPNT?.autocompleteData

  const initAutocompleteFields = () => {
    if (elements.length > 0 && silverstripeData) {
      const autoCompleteJS = new autoComplete({
        name: 'autoComplete',
        selector: selector,
        placeHolder: 'Search for marae',
        diacritics: true, // Allow macrons
        submit: true, // Required to allow Silverstripe keyword search to work
        data: {
          src: silverstripeData,
          keys: ['name'], // The value that autocomplete searches
          cache: true,
        },
        resultsList: {
          class: 'c-autocomplete__results-list',
          element: (list, data) => {
            // A p tag shouldn't be inside a ul element but due to the way autocomplete.js
            // handles selection we can't make the helper text an li element otherwise
            // it breaks the links of the results
            // TODO: looks like we can actually change the tag that is used for resultsList and resultItem to avoid this bad HTML
            // Won't do now as it requires reworking the styling and we can't spend that time right now.
            // resultsList : {
            //   tag: 'div',
            // }
            const helperText = document.createElement('p')
            helperText.classList.add('c-autocomplete__helper-text')
            helperText.innerHTML =
              'Search by <span class="c-autocomplete__helper-entity-types">marae iwi hapū rōhe waka</span>'
            list.prepend(helperText)

            if (data.results.length > 0) {
              const showAllLink = document.createElement('a')
              showAllLink.id = 'autocomplete-show-all'
              showAllLink.innerHTML = 'Show all'
              showAllLink.href = `/search?keyword=${data.query}`

              // Adding the show all link as a list item so that it is keyboard accessible
              const showAllListItem = document.createElement('li')
              showAllListItem.classList.add('c-autocomplete__result-item')
              showAllListItem.classList.add('c-autocomplete__show-all-link')
              showAllListItem.append(showAllLink)

              list.append(showAllListItem)
            }
          },
          noResults: false, // Hide the results list if there are no results
          maxResults: 15,
          tabSelect: true,
        },
        resultItem: {
          class: 'c-autocomplete__result-item',
          element: (item, data) => {
            item.innerHTML = `
            <span class="c-autocomplete__result-name">
              ${data.match}
            </span>
            <span class="c-autocomplete__result-type">
              ${data.value.type}
            </span>
          `
          },
          highlight: true, // Highlight the part of the word that matches the search query
        },
        events: {
          input: {
            selection(event) {
              const feedback = event.detail

              // Check for value so that js doesn't error if the 'show all' link is clicked
              if (feedback.selection.value) {
                // Get selected Value
                const selection = feedback.selection.value.link
                // Navigate to the selected item URL
                window.location.href = selection
              }
            },
            keydown(event) {
              switch (event.keyCode) {
                // Up/Down arrows
                case 40:
                case 38:
                  // Add back built in functionality from the autocomplete.js library
                  event.preventDefault()
                  event.keyCode === 40 ? autoCompleteJS.next() : autoCompleteJS.previous()
                  break
                // Enter
                case 13:
                  // Our customised functionality
                  const weHaveSelectedShowAll = autoCompleteJS.cursor == autoCompleteJS.feedback.results.length

                  if (autoCompleteJS.cursor >= 0 && !weHaveSelectedShowAll) {
                    // If the user presses 'Enter' while they have a result item selected, but NOT the 'Show all' link
                    // then 'prevent default', so don't do a keyword search, and instead take them to the selected page.
                    // 'Show all' link will do the default functionality, aka submit the form, which does the keyword search 🪄
                    event.preventDefault()
                  }
                  autoCompleteJS.select(event)
                  break
                // Tab
                case 9:
                  // Add back built in functionality from the autocomplete.js library
                  if (autoCompleteJS.resultsList.tabSelect && autoCompleteJS.cursor >= 0) autoCompleteJS.select(event)
                  break
                // Escape
                case 27:
                  // Add back built in functionality from the autocomplete.js library
                  autoCompleteJS.input.value = ''
                  autoCompleteJS.close()
                  break
              }
            },
          },
        },
      })
    }
  }

  return {
    init: () => {
      initAutocompleteFields()
    },
  }
})()

export default AutocompleteField
